import type { Action, ResourceType, SagaCallbacks } from '../types';

import * as actionTypes from './actionTypes';

export const requestAddExerciseToWorkout = ({
  workoutId,
  exerciseId,
  workoutType,
  callbacks,
}: {
  workoutId: number;
  exerciseId: number;
  workoutType: string;
  callbacks?: SagaCallbacks;
}): Action => ({
  type: actionTypes.REQUEST_ADD_EXERCISE_TO_WORKOUT,
  workoutId,
  exerciseId,
  workoutType,
  callbacks,
});

export const requestReplaceExerciseInWorkout = ({
  workoutId,
  exerciseId,
  newExerciseId,
  workoutType,
  callbacks,
}: {
  workoutId: number;
  exerciseId: number;
  newExerciseId: number;
  workoutType: string;
  callbacks?: SagaCallbacks;
}): Action => ({
  type: actionTypes.REQUEST_REPLACE_EXERCISE_IN_WORKOUT,
  workoutId,
  exerciseId,
  newExerciseId,
  workoutType,
  callbacks,
});

export const requestAddAlternativeExercise = ({
  workoutId,
  exerciseId,
  alternativeId,
  workoutType,
  callbacks,
}: {
  workoutId: number;
  exerciseId: number;
  alternativeId: number;
  workoutType: string;
  callbacks?: SagaCallbacks;
}): Action => ({
  type: actionTypes.REQUEST_ADD_ALTERNATIVE_EXERCISE,
  workoutId,
  exerciseId,
  alternativeId,
  workoutType,
  callbacks,
});

export const requestSetAlternativeExercise = ({
  exerciseId,
  alternativeId,
  callbacks,
}: {
  exerciseId: number;
  alternativeId: number;
  callbacks?: SagaCallbacks;
}): Action => ({
  type: actionTypes.REQUEST_SET_ALTERNATIVE_EXERCISE,
  exerciseId,
  alternativeId,
  callbacks,
});

export const requestSetExerciseOrderName = ({
  workoutId,
  exerciseId,
  newNumber,
}: {
  workoutId: number;
  exerciseId: number;
  newNumber: number;
}): Action => ({
  type: actionTypes.REQUEST_SET_EXERCISE_ORDER_NAME,
  workoutId,
  exerciseId,
  newNumber,
});

export const requestSaveExerciseProperty = ({
  propertyId,
  payload,
  isNew,
  list,
  callbacks,
}: {
  propertyId: number;
  payload: any;
  isNew: boolean;
  list: string;
  callbacks?: SagaCallbacks;
}): Action => ({
  type: actionTypes.REQUEST_SAVE_EXERCISE_PROPERTY,
  propertyId,
  payload,
  isNew,
  list,
  callbacks,
});

export const requestSaveDieRollOptions = ({
  properties,
  callbacks,
}: {
  properties: any[];
  callbacks?: SagaCallbacks;
}): Action => ({
  type: actionTypes.REQUEST_SAVE_DIE_ROLL_OPTIONS,
  properties,
  callbacks,
});

export const requestAssignProperties = (workoutId: number): Action => ({
  type: actionTypes.REQUEST_ASSIGN_PROPERTIES,
  workoutId,
});

export const requestUnassignFromClient = ({
  id,
  clientId,
  resourceType,
  callbacks,
}: {
  id: number;
  clientId: number;
  resourceType: ResourceType;
  callbacks?: SagaCallbacks;
}): Action => ({
  type: actionTypes.REQUEST_UNASSIGN_FROM_CLIENT,
  id,
  clientId,
  resourceType,
  callbacks,
});
